<template>
  <validation-observer ref="observer" v-slot="{ handleSubmit }">
    <b-form class="mt-4" @submit.stop.prevent="handleSubmit(onSubmit)">
      <div class="d-flex" style="gap:24px;">
        <div style="width:40%">
          <validation-provider name="Name" :rules="{ required: true }" v-slot="validationContext">
            <b-form-group label="Name" label-for="attachment-name">
              <b-form-input
                id="attachment-name"
                v-model="name"
                :state="getValidationState(validationContext)"
              ></b-form-input>
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </div>
        <div style="width:100%">
          <validation-provider name="File" :rules="{ required: true }" v-slot="validationContext">
            <b-form-group label="File" label-for="attachment-file">
              <b-file
                id="attachment-file"
                v-model="file"
                :state="getValidationState(validationContext)"
              />
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </div>
      </div>
      <LoadingIndicator v-if="saving" />
      <b-btn variant="primary" :disabled="saving" type="submit">Create attachment</b-btn>
    </b-form>
  </validation-observer>
</template>

<script>
import LoadingIndicator from '@/components/shared/LoadingIndicator';

export default {
  name: 'AttachmentForm',
  components: { LoadingIndicator },
  props: {
    saving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: null,
      file: null,
    };
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    onSubmit() {
      this.$emit('submit', { name: this.name, file: this.file });
    },
    reset() {
      this.name = null;
      this.file = null;
      this.$nextTick(() => this.$refs.observer.reset());
    },
  },
};
</script>
